var React = require('react');

function StarInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7 10.7793L2.67376 13L3.5 8.29656L0 4.96556L4.83688 4.27934L7 0L9.16312 4.27934L14 4.96556L10.5 8.29656L11.3262 13L7 10.7793Z","fill":"#FF9905"}));
}

StarInline.defaultProps = {"width":"14","height":"13","viewBox":"0 0 14 13","fill":"none"};

module.exports = StarInline;

StarInline.default = StarInline;
